export const toCurrencyFormat = (num: number) => Number(Number(num).toFixed(0)).toLocaleString('id-ID')
